<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-12">
                  <div class="form-group">
                    <label>Excel File <span class="text-danger">*</span></label>
                    <input type="file" class="form-control" ref="excel_file" accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" required />
                  </div>
                </div>
                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Import</button>
                  <router-link to="historyattendance" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>

            <div class="row mt-3 mx-2" v-if="dataSuccess.length > 0">
              <div class="card">
                  <div class="card-body p-0">
                      <ul v-for="item in dataSuccess" :key="index">
                          <li>{{ item }}</li>
                      </ul>
                  </div>
              </div>
            </div>

          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url,AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch } from "@/assets/js/function";

// import { Form, Field } from "vee-validate";
// import * as Yup from "yup";

export default {
  // components: {
  //   Form,
  //   Field,
  // },
  name: "editemployee",
  data() {
    return {
      title: "Import Attendance Excel",
      title1: "manage your employees attendance",
      config: "",
      api: "",
      //data
      currentData: {
      },

      dataSuccess: [],
      
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }

  },
  
  methods: {

    async insert() {
      
      let formData = new FormData();
      appendForm(formData);

      // Object.entries(this.currentData).forEach(([key, value]) => {
      //   formData.append(key, value);
      // });
      formData.append("excel_file", this.$refs.excel_file.files[0]);

      this.dataSuccess = []

      const api = base_url + '/v3/attendances/import';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;
      console.log('ini data import', data)
      if(data.status){

        AlertBottom(data.message);
        this.dataSuccess = data.data
        console.log('ini data hasil impor', this.dataSuccess)
        // goPage('historyattendance')
      }else {  
        AlertPopup2("error", "", data.message, true, 1500);
          
      }

      
    },

  },

};
</script>
